import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardHeader from "components/Card/CardHeader";
import PropTypes from "prop-types";

// react component for creating dynamic tables
import ReactTable from "react-table";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import { MailOutline } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function ListUser(props) {
  const source = React.useRef(new AbortController());
  const classes = useStyles();

  let { id, reloadHandler, reload, disabled } = props;
  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [filter, setFilter] = React.useState({
    searchString: null
  });
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get(
        "/SendAppsNotificationTransactions/" + id + "/Users/availableUsers",
        {
          signal: source.current.signal,
          params: {
            filter: filter,
            pagination: pagination
          }
        }
      )
      .then(data => {
        setData(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <Button
                    color="danger"
                    className="remove"
                    disabled={disabled}
                    onClick={() =>
                      bookingApi
                        .delete(
                          "/SendAppsNotificationTransactions/" +
                            id +
                            "/Users/" +
                            record.user.id,
                          {
                            signal: source.current.signal
                          }
                        )
                        .then(() => reloadHandler())
                        .catch(error => console.log(error))
                    }
                  >
                    <DeleteIcon /> DELETE
                  </Button>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [id, filter, pagination, reload, reloadHandler]);

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>USERS</h4>
          </CardHeader>
          <CardBody>
            <GridItem xs={3}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  id: "name",
                  Header: "Name",
                  accessor: d => d.user.name
                },
                {
                  id: "email",
                  Header: "Email",
                  accessor: d => d.user.email
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

ListUser.propTypes = {
  id: PropTypes.string,
  reloadHandler: PropTypes.func,
  reload: PropTypes.object,
  disabled: PropTypes.bool
};
